import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, useTokens } from "@gemini/core";
import { getContrastColor } from "@/utils/getContrastColor";
import { TransportType } from "../../../types";
export const TransportLineIcon = ({ line, type, BoxProps, }) => {
    const { "color.background.subdued": fallbackColor, "color.background.default": white, "color.border.default.default": black, } = useTokens();
    const lineBackground = line.color || fallbackColor;
    const lineTextColor = getContrastColor(lineBackground, white, black);
    if (type === TransportType.TRAM) {
        return (_jsxs(Box, Object.assign({ height: "sizing.24", width: "sizing.24", textAlign: "center", typography: "typography.body.11.bold" }, BoxProps, { children: [_jsx(Box, { height: "sizing.4", width: "100%", borderRadius: "radius.4", backgroundColor: lineBackground }), _jsx(Box, { as: "span", children: line.name }), _jsx(Box, { height: "sizing.4", width: "100%", borderRadius: "radius.4", backgroundColor: lineBackground })] })));
    }
    return (_jsx(Box, Object.assign({ unsafe_style: {
            borderColor: lineBackground,
            backgroundColor: lineBackground,
            color: lineTextColor,
        }, borderRadius: "radius.rounded", height: "sizing.20", minWidth: "sizing.20", typography: "typography.body.11.bold", display: "flex", alignItems: "center", justifyContent: "center", paddingVertical: "spacing.2", paddingHorizontal: "spacing.8" }, BoxProps, { children: line.name })));
};
